// 9-line CAS-komponist (nærstøtte): strukturert 9-linjers innmelding → formatert
// brief. Plasseres på kartsenter og deles som stridsmelding (CONTACT) med brief-en
// i klartekst, så TOC/flystøtte ser den. Samme panel-mønster som andre komponister.
import { NineLineCasSchema, buildNineLineText, type NineLineCas } from '@skade/contracts';

interface Field { key: keyof NineLineCas; label: string; long?: boolean; num?: boolean }
const FIELDS: Field[] = [
  { key: 'ipHp', label: 'Linje 1 — IP/BP (kontrollpunkt)' },
  { key: 'heading', label: 'Linje 2 — Kurs IP→mål (+offset)' },
  { key: 'distanceM', label: 'Linje 3 — Avstand (m)', num: true },
  { key: 'targetElevM', label: 'Linje 4 — Målhøyde (m)', num: true },
  { key: 'targetDesc', label: 'Linje 5 — Målbeskrivelse', long: true },
  { key: 'markType', label: 'Linje 7 — Markering av mål' },
  { key: 'friendlies', label: 'Linje 8 — Nærmeste egne' },
  { key: 'egress', label: 'Linje 9 — Retrett' },
  { key: 'remarks', label: 'Merknader', long: true },
];

export type NineLineSubmit = (n: NineLineCas) => void;

export class NineLineComposer {
  readonly el: HTMLElement;
  private open = false;

  constructor(private onSubmit: NineLineSubmit) {
    this.el = this.build();
  }

  toggle() { this.open ? this.close() : this.show(); }
  private show() { this.open = true; this.el.classList.add('open'); }
  close() { this.open = false; this.el.classList.remove('open'); }

  private build(): HTMLElement {
    const p = div('report-composer nineline-composer');
    const head = div('report-head');
    head.append(span('report-title', '9-line CAS (nærstøtte)'));
    const x = document.createElement('button');
    x.className = 'report-x'; x.textContent = '×'; x.onclick = () => this.close();
    head.append(x);
    p.append(head);

    const form = div('report-form');
    const inputs = new Map<keyof NineLineCas, HTMLInputElement | HTMLTextAreaElement>();
    for (const f of FIELDS) {
      const wrap = div('report-field');
      wrap.append(span('report-field-label', f.label));
      const input = f.long ? document.createElement('textarea') : document.createElement('input');
      input.className = 'report-input';
      if (f.num) (input as HTMLInputElement).type = 'number';
      inputs.set(f.key, input);
      wrap.append(input);
      form.append(wrap);
    }
    const submit = document.createElement('button');
    submit.className = 'report-submit'; submit.textContent = 'Send 9-line (på kartsenter)';
    submit.onclick = () => {
      const raw: Record<string, unknown> = { id: `9l-${Date.now().toString(36)}`, tsMs: Date.now(), targetLat: 0, targetLon: 0 };
      for (const [k, el] of inputs) {
        const f = FIELDS.find((x) => x.key === k)!;
        raw[k] = f.num ? Number(el.value || 0) : el.value.trim();
      }
      const parsed = NineLineCasSchema.safeParse(raw);
      if (parsed.success) { this.onSubmit(parsed.data); this.close(); }
    };
    form.append(submit);
    p.append(form);
    return p;
  }
}

export { buildNineLineText };
function div(cls: string): HTMLElement { const e = document.createElement('div'); e.className = cls; return e; }
function span(cls: string, text: string): HTMLElement { const e = document.createElement('span'); e.className = cls; e.textContent = text; return e; }
